/* tslint:disabled */
/* eslint-disable */
/**
 * Alerts
 * The service provides RESTful API for manipulating alerts (CRUD)
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AlertStatusEnum {
  None = 'ALERT_STATUS_NONE',
  New = 'ALERT_STATUS_NEW',
  Open = 'ALERT_STATUS_OPEN',
  Ignore = 'ALERT_STATUS_IGNORE',
  Close = 'ALERT_STATUS_CLOSE'
}

export function AlertStatusEnumFromJSON(json: any): AlertStatusEnum {
  return json as AlertStatusEnum
}

export function AlertStatusEnumToJSON(value?: AlertStatusEnum): any {
  return value as any
}
